export default {
      id: "calendar-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.svg#calendar",
      toString: function () {
        return this.url;
      }
    }